import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";

var reduce = require("lodash/reduce");

var map = require("lodash/map");

var reject = require("lodash/reject");

var isUndefined = require("lodash/isUndefined");

export var Utils =
/*#__PURE__*/
function () {
  function Utils() {
    _classCallCheck(this, Utils);
  }

  _createClass(Utils, null, [{
    key: "guid",
    value: function guid() {
      var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var id = ++Utils.guidCounter;
      return prefix.toString() + id;
    }
  }, {
    key: "collapse",
    value: function collapse(collection, seed) {
      var reducer = function reducer(current, fn) {
        return fn(current);
      };

      return reduce(collection, reducer, seed);
    }
  }, {
    key: "instanceOf",
    value: function instanceOf(klass) {
      return function (val) {
        return val instanceof klass;
      };
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, interpolations) {
      return str.replace(/{([^{}]*)}/g, function (a, b) {
        var r = interpolations[b];
        return typeof r === 'string' || typeof r === 'number' ? r : a;
      });
    }
  }, {
    key: "translate",
    value: function translate(key, interpolations) {
      if (interpolations) {
        return Utils.interpolate(key, interpolations);
      } else {
        return key;
      }
    }
  }, {
    key: "computeOptionKeys",
    value: function computeOptionKeys(options, fields, defaultKey) {
      return map(options, function (option) {
        return Utils.generateKeyFromFields(option, fields, defaultKey);
      });
    }
  }, {
    key: "generateKeyFromFields",
    value: function generateKeyFromFields(ob, fields, defaultKey) {
      if (ob.key) {
        return ob;
      }

      var fieldValues = reject(map(fields, function (field) {
        return ob[field];
      }), isUndefined);

      if (fieldValues.length > 0) {
        ob.key = fieldValues.join("_");
      } else {
        ob.key = defaultKey;
      }

      return ob;
    }
  }]);

  return Utils;
}();
Utils.guidCounter = 0;